<div class="horizontalMenucontainer">
  <div class="page">
    <div class="page-main">
      <!-- // header -->
      <app-header></app-header>
      <!-- //sidebar -->
      <app-sidebar appHoverEffectSidebar></app-sidebar>
      <div class="app-content main-content">
        <div class="side-app" [ngClass]="{ 'pt-60': scrolled }">
          <div class="main-container container-fluid" (click)="toggleSwitcherBody()">

            <!-- // contetnt  -->
            <router-outlet><app-loader></app-loader></router-outlet>
          </div>
        </div>
      </div>
    </div>
    <!-- <app-footer></app-footer> -->
  </div>
</div>
<!-- <app-tab-to-top></app-tab-to-top> commented-->